export default "__VITE_ASSET__Cg49XWUR__"